<template>
	<v-container fluid class="pt-0">
		<v-row>
			<v-col cols="12" xl="12" lg="12" md="12">
				<v-tabs>
					<v-tab>{{ $t('tabs.basicInfo') }}</v-tab>
					<v-tab-item>
						<v-row>
							<v-flex lg12 xs12 sm12 class="pt-0">
								<v-card flat outlined>
									<v-card-text class="pa-6">
										<v-row>
											<v-flex xs12 md6 lg6>
												<v-card-title class="pa-2">{{
													$t('titles.paymentContractInformations')
												}}</v-card-title>
											</v-flex>
											<v-flex class="d-flex justify-end">
												<v-btn
													v-if="inEditMode"
													class="ml-2"
													color="primary"
													@click="saveClick(true, true)"
												>
													<v-icon small>fa-save</v-icon>&nbsp;{{
														$t('buttons.saveAndCreateInvoice')
													}}
												</v-btn>
												<v-btn
													v-if="inEditMode"
													class="ml-2"
													color="primary"
													@click="saveClick(false)"
												>
													<v-icon small>fa-save</v-icon>&nbsp;{{ $t('buttons.saveAndClose') }}
												</v-btn>
												<v-btn
													v-if="inEditMode"
													class="ml-2"
													color="primary"
													@click="saveClick(true)"
												>
													<v-icon small>fa-save</v-icon>&nbsp;{{ $t('buttons.save') }}
												</v-btn>
												<v-btn
													v-if="
														!inEditMode && paymentContract.payment_contract_status_id == 1
													"
													class="ml-2 mr-2 white--text"
													color="#14426c"
													@click="closeContractClick()"
												>
													<v-icon small>fa-trash</v-icon>&nbsp;{{
														$t('buttons.closeContract')
													}}
												</v-btn>
												<v-btn
													v-if="
														!inEditMode &&
														deletionPossible &&
														$myStore.state.user.user_role_id == 1
													"
													class="ml-2 mr-2"
													color="warning"
													@click="deleteClick()"
												>
													<v-icon small>fa-lock</v-icon>&nbsp;{{ $t('buttons.delete') }}
												</v-btn>
												<v-btn
													v-if="
														!inEditMode && paymentContract.payment_contract_status_id == 2
													"
													class="ml-2 mr-2 white--text"
													color="#14426c"
													@click="openContractClick()"
												>
													<v-icon small>fa-lock-open</v-icon>&nbsp;{{
														$t('buttons.openPaymentContract')
													}}
												</v-btn>
												<v-btn
													v-if="
														!inEditMode && paymentContract.payment_contract_status_id == 1
													"
													class="ml-2"
													color="primary"
													@click="editClick()"
												>
													<v-icon small>fa-edit</v-icon>&nbsp;{{ $t('buttons.edit') }}
												</v-btn>
												<v-btn class="ml-2 mr-2" color="basicButton" @click="backClick">
													<v-icon small>fa-reply</v-icon>&nbsp;{{ $t('buttons.back') }}
												</v-btn>
											</v-flex>
										</v-row>
										<v-row wrap>
											<v-flex lg6 md6 sm12 xs12>
												<v-col cols="12">
													<DatePicker
														:disabled="true"
														v-model="paymentContract.date"
														:errorBorder="!paymentContractValidation.date"
														:date-label="$t('fields.date')"
													></DatePicker>
												</v-col>
												<v-row class="pb-0">
													<v-flex xs12 sm12 md12 lg12 class="pb-0 pl-4 pt-2">
														<div
															:class="[
																'text-body-1',
																'pt-5',
																'pl-2',
																'mr-4',
																'd-inline-block',
															]"
														>
															{{ $t('labels.buyerType') }}
														</div>
														<v-radio-group
															v-model="paymentContract.contract_type"
															row
															mandatory
															class="d-inline-block"
															:disabled="
																$route.params.id != 0 ||
																paymentContract.payment_contract_status_id == 2
															"
														>
															<v-radio
																:label="$t('fields.partner')"
																value="partner"
															></v-radio>
															<v-radio
																:label="$t('fields.candidate')"
																value="candidate"
															></v-radio>
														</v-radio-group>
													</v-flex>
												</v-row>
												<v-col cols="12" v-if="paymentContract.contract_type == 'candidate'">
													<Dropdown2
														:disabled="
															$route.params.id != 0 ||
															paymentContract.payment_contract_status_id == 2
														"
														:readonly="!inEditMode"
														v-model="paymentContract.candidate_id"
														:ajax="true"
														:data="'candidates'"
														:errorBorder="!paymentContractValidation.candidate_id"
														:label="'* ' + $t('fields.candidate')"
														@item-selected="getLoyaltyPoints"
													></Dropdown2>
												</v-col>
												<v-col cols="12" v-if="paymentContract.contract_type == 'partner'">
													<Dropdown
														:disabled="
															$route.params.id != 0 ||
															paymentContract.payment_contract_status_id == 2
														"
														:readonly="!inEditMode"
														v-model="paymentContract.partner_id"
														:ajax="true"
														:data="'partners-buyers'"
														:errorBorder="!paymentContractValidation.partner_id"
														:label="'* ' + $t('fields.partner')"
													></Dropdown>
												</v-col>
												<v-col
													cols="12"
													v-if="
														paymentContract.contract_type == 'candidate' &&
														candidateLoyaltyConsent == true
													"
												>
													<InputField
														:disabled="true"
														v-model="candidateLoyaltyPoints"
														:label="'* ' + $t('fields.loyaltyPoints')"
													></InputField>
												</v-col>
												<v-col cols="12">
													<InputField
														:disabled="true"
														v-model="paymentContract.status_name"
														:label="'* ' + $t('fields.paymentContractStatus')"
													></InputField>
												</v-col>
												<v-col cols="12">
													<TextArea
														:disabled="paymentContract.payment_contract_status_id == 2"
														:readonly="!inEditMode"
														v-model="paymentContract.note"
														:errorBorder="!paymentContractValidation.note"
														:label="$t('fields.note')"
														rows="3"
													></TextArea>
												</v-col>
												<v-col
													cols="12"
													class="pt-2"
													v-if="
														paymentContract.contract_type == 'candidate' &&
														candidateLoyaltyConsent == true
													"
												>
													<CheckBox
														:disabled="
															paymentContract.contract_type == 'partner' ||
															candidateLoyaltyPoints < 130 ||
															candidateLoyaltyPoints == null ||
															paymentContract.payment_contract_status_id == 2 ||
															loyaltyDiscountUsed
														"
														:readonly="!inEditMode"
														v-model="paymentContract.loyalty_discount"
														:label="$t('fields.loyaltyDiscount')"
													></CheckBox>
												</v-col>
												<v-col cols="2">
													<CheckBox
														:disabled="$route.params.id != 0"
														v-model="paymentContract.vat_exists"
														:label="$t('fields.vat2')"
													></CheckBox>
												</v-col>
											</v-flex>
											<v-flex lg6 md6 sm12 xs12>
												<v-row class="pt-10">
													<v-flex lg6 md6 sm6 xs12 class="pl-16 pr-2">
														<v-row>
															<v-col cols="12">
																<div
																	style="border-color: #0c790e"
																	class="thick-border-rounded"
																>
																	<div
																		style="color: #0c790e"
																		:class="['text-subtitle-1', 'font-weight-bold']"
																	>
																		{{ $t('fields.payed2') }}
																	</div>
																	<div
																		style="color: #0c790e"
																		class="thick-value font-weight-bold"
																		:class="['text-h4', 'font-weight-bold']"
																	>
																		{{
																			Number.isInteger(paymentContract.payed)
																				? paymentContract.payed.toLocaleString(
																						'hr'
																				  ) + ',00 €'
																				: /^\d+\.\d{1}$/.test(
																						paymentContract.payed.toString()
																				  )
																				? paymentContract.payed.toLocaleString(
																						'hr'
																				  ) + '0 €'
																				: paymentContract.payed.toLocaleString(
																						'hr'
																				  ) + ' €'
																		}}
																	</div>
																</div>
															</v-col>
														</v-row>
														<v-row>
															<v-col cols="12">
																<div
																	style="border-color: var(--v-totalBruto-base)"
																	class="thick-border-rounded"
																>
																	<div
																		style="color: var(--v-totalBruto-base)"
																		:class="['text-subtitle-1', 'font-weight-bold']"
																	>
																		{{ $t('fields.totalBruto') }}
																	</div>
																	<div
																		style="color: var(--v-totalBruto-base)"
																		:class="['text-h4', 'font-weight-bold']"
																	>
																		{{
																			Number.isInteger(
																				paymentContract.total_bruto
																			)
																				? paymentContract.total_bruto.toLocaleString(
																						'hr'
																				  ) + ',00 €'
																				: /^\d+\.\d{1}$/.test(
																						paymentContract.total_bruto.toString()
																				  )
																				? paymentContract.total_bruto.toLocaleString(
																						'hr'
																				  ) + '0 €'
																				: paymentContract.total_bruto.toLocaleString(
																						'hr'
																				  ) + ' €'
																		}}
																	</div>
																</div>
															</v-col>
														</v-row>
														<v-row>
															<v-col cols="12">
																<div
																	style="border-color: #7a7a7a"
																	class="thick-border-rounded"
																>
																	<div
																		style="color: #7a7a7a"
																		:class="['text-subtitle-1', 'font-weight-bold']"
																	>
																		{{ $t('fields.discount') }}
																	</div>
																	<div
																		style="color: #7a7a7a"
																		:class="['text-h4', 'font-weight-bold']"
																	>
																		{{
																			Number.isInteger(paymentContract.discount)
																				? paymentContract.discount.toLocaleString(
																						'hr'
																				  ) + ',00 €'
																				: /^\d+\.\d{1}$/.test(
																						paymentContract.discount.toString()
																				  )
																				? paymentContract.discount.toLocaleString(
																						'hr'
																				  ) + '0 €'
																				: paymentContract.discount.toLocaleString(
																						'hr'
																				  ) + ' €'
																		}}
																	</div>
																</div>
															</v-col>
														</v-row>
													</v-flex>
													<v-flex lg6 md6 sm6 xs12 class="pl-2 pr-16">
														<v-row>
															<v-col cols="12">
																<div
																	style="border-color: #d1393e"
																	class="thick-border-rounded"
																>
																	<div
																		style="color: #d1393e"
																		:class="['text-subtitle-1', 'font-weight-bold']"
																	>
																		{{ $t('fields.owes') }}
																	</div>
																	<div
																		style="color: #d1393e"
																		:class="['text-h4', 'font-weight-bold']"
																	>
																		{{
																			Number.isInteger(paymentContract.debt)
																				? paymentContract.debt.toLocaleString(
																						'hr'
																				  ) + ',00 €'
																				: /^\d+\.\d{1}$/.test(
																						paymentContract.debt.toString()
																				  )
																				? paymentContract.debt.toLocaleString(
																						'hr'
																				  ) + '0 €'
																				: paymentContract.debt.toLocaleString(
																						'hr'
																				  ) + ' €'
																		}}
																	</div>
																</div>
															</v-col>
														</v-row>
														<v-row>
															<v-col cols="12">
																<div
																	style="border-color: #7e74fc"
																	class="thick-border-rounded"
																>
																	<div
																		style="color: #7e74fc"
																		:class="['text-subtitle-1', 'font-weight-bold']"
																	>
																		{{ $t('fields.totalNeto') }}
																	</div>
																	<div
																		style="color: #7e74fc"
																		:class="['text-h4', 'font-weight-bold']"
																	>
																		{{
																			Number.isInteger(paymentContract.total)
																				? paymentContract.total.toLocaleString(
																						'hr'
																				  ) + ',00 €'
																				: /^\d+\.\d{1}$/.test(
																						paymentContract.total.toString()
																				  )
																				? paymentContract.total.toLocaleString(
																						'hr'
																				  ) + '0 €'
																				: paymentContract.total.toLocaleString(
																						'hr'
																				  ) + ' €'
																		}}
																	</div>
																</div>
															</v-col>
														</v-row>
														<v-row>
															<v-col cols="12">
																<div
																	style="border-color: #b9bd21"
																	class="thick-border-rounded"
																>
																	<div
																		style="color: #b9bd21"
																		:class="['text-subtitle-1', 'font-weight-bold']"
																	>
																		{{ $t('fields.loyaltyPoints') }}
																	</div>
																	<div
																		style="color: #b9bd21"
																		:class="['text-h4', 'font-weight-bold']"
																	>
																		{{ paymentContract.loyalty_points }}
																	</div>
																</div>
															</v-col>
														</v-row>
													</v-flex>
												</v-row>
											</v-flex>
										</v-row>
									</v-card-text>
								</v-card>
							</v-flex>
						</v-row>
						<v-row>
							<v-flex lg6 xs12 sm12 class="pt-0">
								<v-card flat outlined>
									<PaymentContractItems
										:paymentContractStatus="paymentContract.payment_contract_status_id"
										:vatExists="paymentContract.vat_exists"
										@tempItems="handleItems"
									></PaymentContractItems>
								</v-card>
							</v-flex>
							<v-flex lg6 xs12 sm12 class="pt-0">
								<v-card flat outlined>
									<PaymentContractUsedItems
										@deletionPossible="deletionState"
									></PaymentContractUsedItems>
								</v-card>
							</v-flex>
						</v-row>
						<v-row v-if="$route.params.id != 0">
							<v-flex lg6 xs12 sm12 class="pt-0">
								<v-card flat outlined>
									<PaymentContractBills
										:createInvoiceAfterSaving="createInvoice"
										:redirectionRoute="redirectionRoute"
									></PaymentContractBills>
								</v-card>
							</v-flex>
							<v-flex lg6 xs12 sm12 class="pt-0">
								<v-card flat outlined>
									<PaymentContractTransactions></PaymentContractTransactions>
								</v-card>
							</v-flex>
						</v-row>
					</v-tab-item>
				</v-tabs>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import InputField from '../../trinkets/InputField';
import DatePicker from '../../trinkets/DatePicker';
import TextArea from '../../trinkets/TextArea';
import CheckBox from '../../trinkets/CheckBox';
import Dropdown from '../../trinkets/Dropdown';
import Dropdown2 from '../../trinkets/Dropdown2';
import PaymentContract from '../../../models/PaymentContract';
import PaymentContractItems from './PaymentContractItems';
import PaymentContractUsedItems from './PaymentContractUsedItems';
import PaymentContractTransactions from './PaymentContractTransactions';
import PaymentContractBills from './PaymentContractBills';

export default {
	name: 'PaymentContract',
	components: {
		InputField,
		DatePicker,
		TextArea,
		Dropdown,
		Dropdown2,
		CheckBox,
		PaymentContractItems,
		PaymentContractUsedItems,
		PaymentContractTransactions,
		PaymentContractBills,
	},
	data: function () {
		return {
			paymentContract: new PaymentContract({
				id: this.$route.params.id,
				date: new Date().toISOString().split('T')[0],
			}),
			paymentContractValidation: new PaymentContract({}, true),
			initialLoad: false,
			inEditMode: false,
			lockKey: 'paymentContract',
			lockTimer: null,
			candidateLoyaltyPoints: 0,
			candidateLoyaltyConsent: false,
			loyaltyDiscountUsed: false,
			deletionPossible: false,
			redirectionRoute: null,
			createInvoice: false,
		};
	},
	watch: {
		'paymentContract.contract_type'(newVal) {
			if (newVal == 'partner') {
				this.paymentContract.loyalty_discount = false;
				this.paymentContract.candidate_id = null;
			} else {
				this.paymentContract.partner_id = null;
			}
		},
	},
	methods: {
		editClick() {
			let vm = this;
			this.$setLock(this, this.lockKey + '|' + this.paymentContract.id, (data) => {
				if (data.success) {
					vm.inEditMode = true;
					vm.lockTimer = setInterval(() => {
						vm.$setLock(vm, vm.lockKey + '|' + vm.paymentContract.id);
					}, 10000);
				} else {
					vm.$alert(
						vm
							.$t('alerts.recordLocked')
							.split('%name%')
							.join(data.locked_by.first_name + ' ' + data.locked_by.last_name)
					);
				}
			});
		},
		backClick() {
			this.$router.push('/payment-contracts');
		},
		deletionState(state) {
			this.deletionPossible = state;
		},
		deleteClick() {
			let vm = this;
			if (this.deletionPossible) {
				this.$verify(this.$t('alerts.deletionQuestion'), (result) => {
					if (result) {
						vm.$APICall(
							'delete',
							'payment-contracts/' + this.$route.params.id + '/delete',
							null,
							(data, success) => {
								if (success) {
									vm.$notify(vm.$t('alerts.basicDelete'));
									vm.backClick();
								} else {
									vm.$alert(vm.$t('alerts.basicError'));
								}
							}
						);
					}
				});
			} else {
				vm.$alert(vm.$t('alerts.deleteError'));
			}
		},
		handleItems(items) {
			this.paymentContract.items = items;
			this.paymentContract.total = 0;
			this.paymentContract.total_bruto = 0;
			this.paymentContract.discount = 0;
			let courses_total_neto = 0;
			for (const item of items) {
				this.paymentContract.total += item['total'];
				this.paymentContract.total_bruto += item['total_bruto'];
				this.paymentContract.discount += item['unit_discount'] * item['quantity'];
				if (item['payment_contract_item_type_id'] == 1) {
					courses_total_neto += item['total'];
				}
			}
			this.paymentContract.debt = this.paymentContract.total_bruto;
			this.paymentContract.loyalty_points = Math.floor(courses_total_neto / 10.62);
		},
		getLoyaltyPoints(item) {
			var vm = this;
			this.$APICall(
				'get',
				'candidate-loyalty-points/' + item.id,
				{},
				(data, success) => {
					if (success) {
						vm.candidateLoyaltyPoints = data.loyalty_points;
						vm.candidateLoyaltyConsent = data.loyalty_consent;
					}
				},
				false
			);
		},
		closeContractClick() {
			this.$verify(this.$t('alerts.closeContractQuestion'), (result) => {
				if (result) {
					this.paymentContract.payment_contract_status_id = 2;
					this.saveClick();
				}
			});
		},
		openContractClick() {
			this.$verify(this.$t('alerts.openContractQuestion'), (result) => {
				if (result) {
					this.paymentContract.payment_contract_status_id = 1;
					this.saveClick();
				}
			});
		},
		saveClick(after = false, createInvoice = false) {
			let success = true;
			let errorMessages = '';

			if (this.paymentContract.note != null && this.paymentContract.note != '') {
				if (this.paymentContract.note.length > 750) {
					success = false;
					this.paymentContractValidation.note = false;
					errorMessages +=
						this.$t('alerts.lengthError')
							.replace('%field%', this.$t('fields.note'))
							.replace('%length%', '750') + '<br />';
				} else {
					this.paymentContractValidation.note = true;
				}
			}

			if (this.paymentContract.contract_type == 'partner') {
				this.paymentContract.candidate_id == null;
				this.paymentContract.payment_contract_type_id = 1;
			}

			if (this.paymentContract.contract_type == 'candidate') {
				this.paymentContract.partner_id == null;
				this.paymentContract.payment_contract_type_id = 2;
			}

			if (
				this.paymentContract.payment_contract_type_id == 1 &&
				(this.paymentContract.partner_id == null || this.paymentContract.partner_id === '')
			) {
				success = false;
				this.paymentContractValidation.partner_id = false;
			} else {
				this.paymentContractValidation.partner_id = true;
			}

			if (
				this.paymentContract.payment_contract_type_id == 2 &&
				(this.paymentContract.candidate_id == null || this.paymentContract.candidate_id === '')
			) {
				success = false;
				this.paymentContractValidation.candidate_id = false;
			} else {
				this.paymentContractValidation.candidate_id = true;
			}

			if (errorMessages !== '') {
				this.$alert(errorMessages);
				success = false;
			}

			if (success) {
				let vm = this;
				let action = 'post';
				let addition = '';
				let contractId = parseInt(vm.paymentContract.id, 10);
				if (contractId > 0) {
					action = 'put';
					addition = '/' + contractId;
				}
				this.$APICall(action, 'payment-contracts' + addition, this.paymentContract, (data, success) => {
					if (success) {
						vm.inEditMode = false;
						if (vm.paymentContract.id == 0) {
							vm.$notify(vm.$t('alerts.basicAdd'));
						} else {
							vm.$notify(vm.$t('alerts.basicUpdate'));
						}

						if (after) {
							if (this.lockTimer !== null) clearInterval(this.lockTimer);
							if (vm.$route.params.id != 0) vm.$removeLock(vm, vm.lockKey + '|' + vm.paymentContract.id);
							this.$router.push('/payment-contracts/' + data.id).catch(() => {});
							vm.paymentContract.id = data.id;
							vm.$modalBus.$emit('reloadPaymentContractItems');
							vm.createInvoice = createInvoice;
							vm.fetchData();
							return;
						}

						if (!after) {
							vm.$router.push(vm.redirectionRoute);
						} else {
							vm.backClick();
						}
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				});
			}
		},
		setBreadcrumbs(addingItem = true) {
			let vm = this;
			if (addingItem) {
				this.$myStore.commit('setBreadcrumbs', [
					{
						text: this.$t('modules.paymentContracts'),
						href: '/#/payment-contracts',
						disabled: false,
					},
					{
						text: this.$t('modules.newPaymentContract'),
						href: '/#/payment-contracts/0',
						disabled: true,
					},
				]);
			} else {
				this.$myStore.commit('setBreadcrumbs', [
					{
						text: vm.$t('modules.paymentContracts'),
						href: '/#/payment-contracts',
						disabled: false,
					},
					{
						text: vm.paymentContract.id,
						href: '/#/payment-contracts/' + vm.paymentContract.id,
						disabled: true,
					},
				]);
			}
		},
		fetchData(refreshing = false) {
			let vm = this;
			this.$APICall('get', 'payment-contracts/' + this.$route.params.id, {}, (data, success) => {
				if (success) {
					let usableData = JSON.parse(JSON.stringify(data));
					vm.paymentContract = usableData;
					vm.loyaltyDiscountUsed = vm.paymentContract.loyalty_discount;
					if (vm.paymentContract.contract_type == 'candidate') {
						vm.candidateLoyaltyConsent = vm.paymentContract.candidate.loyalty_consent;
						vm.candidateLoyaltyPoints = vm.paymentContract.candidate.loyalty_points;
					}
					if (!refreshing) {
						vm.setBreadcrumbs(false);
					}
					vm.$nextTick(() => {
						vm.initialLoad = true;
					});
				}
			});
		},
	},
	beforeRouteLeave(to, from, next) {
		let vm = this;
		if (this.inEditMode) {
			this.$verify(this.$t('alerts.leaveQuestion'), (result) => {
				if (result) {
					if (vm.lockTimer !== null) clearInterval(vm.lockTimer);
					vm.$removeLock(vm, vm.lockKey + '|' + vm.paymentContract.id);
					next(true);
				} else {
					next(false);
				}
			});
		} else {
			if (this.lockTimer !== null) clearInterval(this.lockTimer);
			vm.$removeLock(vm, vm.lockKey + '|' + vm.paymentContract.id);
			next(true);
		}
	},
	beforeRouteEnter(to, from, next) {
		next((vm) => {
			vm.redirectionRoute = from.path;
		});
	},

	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('/login');
		}

		let vm = this;
		this.$modalBus.$on('reloadPaymentContract', () => {
			vm.fetchData(true);
		});

		if (this.$route.params.candidateId) {
			this.paymentContract.contract_type = this.$route.params.contractType;
			this.paymentContract.candidate_id = this.$route.params.candidateId;
			this.getLoyaltyPoints({ id: this.$route.params.candidateId });
			// this.redirectionRoute = '/planned-courses/' + this.$route.params.plannedCourseId;
		}

		if (parseInt(this.paymentContract.id, 10) > 0) {
			this.fetchData();
		} else {
			this.setBreadcrumbs();
			this.inEditMode = true;
			this.initialLoad = true;
		}
	},
};
</script>

<style scoped>
.thick-border-rounded {
	border: 10px solid #333;
	border-radius: 30px;
	padding: 8px;
	text-align: center;
	min-width: 200px;
}
</style>
